import { Platform } from "react-native";

export const getTestId = (name: string) => {
  if (Platform.OS === "web") return { "data-testid": name };
  return { testID: name };
};
